import { takeEvery, put, call } from "redux-saga/effects"
import {
  CREATE_APPLICATION,
  EDIT_APPLICATION,
  REGENERATE_APP_KEY,
  GET_ACCOUNT_SETTING,
  CHANGE_PASSWORD,
  EDIT_ACCOUNT_SETTING,
  DELETE_APPLICATION,
  VERIFY_OTP,
  TOGGLE_TWO_FACTOR_AUTH,
  RESEND_OTP,
  VERIFY_CURRENT_PASSWORD,
  SEND_EMAIL,
  UPDATE_CONTACT_DETAILS,
  VERIFY_LOGIN_OTP,
  VERIFY_EMAIL,
  RESEND_LOGIN_OTP
} from "./actionTypes"
import {
  setCreateApplicationStatus, setEditApplicationStatus, setRegenerateAppkeyStatus,
  getAccountSettingSuccess,
  changePasswordSuccess,
  editAccountSettingSuccess,
  setDeleteApplicationStatus,
  setOTPStatus,
  setTwoFactorAuthStatus,
  setResendOtpStatus,
  setVerifyCurrentPassword,
  setSendEmailStatus,
  setOTPLoginStatus,
  setVerifyEmail,
  setResendLoginOtpStatus,
  setUpdateContactDetails
} from "./actions"
import {
  LystfaceCreateApp, LystfaceEditApp, LystfaceRegenerateAppKey, LystfaceGetAccountSetting,
  LystfaceChangePassword, LystfaceEditAccountSetting,
  LystfaceDeleteApp,
  LystfaceVerifyOTP,
  LystfaceTwoFactorAuth,
  LystfaceResendOTP,
  LystfaceVerifyCurrentPswd,
  LystfaceSendEmail,
  LystfaceUpdateContact,
  LystfaceVerifyLoginOTP,
  LystfaceVerifyEmail,
  LystfaceResendLoginOTP
} from "../../../helpers/lystface_helper"
import { updateActiveManageApp } from "../home/actions"
import Cookies from 'js-cookie'

function* watchForCreateApplication({ payload }) {
  const { formData, application_icon } = payload
  try {
    const CreateAppResult = yield call(LystfaceCreateApp, formData)
    let Response = { ...CreateAppResult, response: { ...CreateAppResult?.response, application_icon: application_icon ? application_icon : CreateAppResult?.response?.app_icon_url } }
    if (CreateAppResult.responseCode == true) {
      yield put(setCreateApplicationStatus(Response))
    } else {
      yield put(setCreateApplicationStatus(Response))

    }
  } catch (error) {
    console.log(error)
    yield put(setCreateApplicationStatus({ responseStatus: "Error", responseMessage: "There was an error creating the application, please try again later!" }))
  }
}
function* watchForEditApplication({ payload }) {
  const { formData, application_icon, appId } = payload
  try {
    const EditAppResult = yield call(LystfaceEditApp, formData)
    let Response = { ...EditAppResult, response: { ...EditAppResult?.response, application_icon: application_icon ? application_icon : EditAppResult?.response?.app_icon_url, app_id: appId } }
    if (EditAppResult.responseCode == true) {
      yield put(setEditApplicationStatus(Response))
      yield put(updateActiveManageApp(EditAppResult.response))
    } else {
      yield put(setEditApplicationStatus(Response))

    }
  } catch (error) {
    console.log(error)
    yield put(setEditApplicationStatus({ responseStatus: "Error", responseMessage: "There was an error updating the application, please try again later!" }))
  }
}
function* watchForRegenerateAppKey({ payload }) {
  try {
    const AppKeyResult = yield call(LystfaceRegenerateAppKey, payload)
    if (AppKeyResult.responseCode == true) {
      yield put(setRegenerateAppkeyStatus(AppKeyResult))
    } else {
      yield put(setRegenerateAppkeyStatus(AppKeyResult))

    }
  } catch (error) {
    yield put(setRegenerateAppkeyStatus({ responseMessage: "There was an error generating app key, please try again later!", responseStatus: 'Error' }))
    console.log(error)
  }
}
function* getAccountDataApi({ }) {
  try {
    const CreateAppResult = yield call(LystfaceGetAccountSetting)
    if (CreateAppResult.responseCode == true) {
      yield put(getAccountSettingSuccess(CreateAppResult))
    } else {
      yield put(getAccountSettingSuccess(CreateAppResult))
    }
  } catch (error) {
    console.log(error)
  }
}
function* changePassword({ payload }) {
  try {
    const CreateAppResult = yield call(LystfaceChangePassword, payload)
    if (CreateAppResult.responseCode == true) {
      yield put(changePasswordSuccess(CreateAppResult))
    } else {
      yield put(changePasswordSuccess(CreateAppResult))
    }
  } catch (error) {
    yield put(changePasswordSuccess({ responseStatus: "Error", responseMessage: "Errro while updating the password" }))
    console.log(error)
  }
}

function* editAccountSetting({ payload }) {
  try {
    const { formData, user_icon, user_deleted } = payload
    const CreateAppResult = yield call(LystfaceEditAccountSetting, formData)
    let Result = { ...CreateAppResult, response: { ...CreateAppResult?.response, profile_icon: user_icon ? user_icon : CreateAppResult?.response?.user_icon, profile_deleted: user_deleted } }
    if (CreateAppResult.responseCode == true) {
      yield put(editAccountSettingSuccess(Result))
    } else {
      yield put(editAccountSettingSuccess(CreateAppResult))
    }
  } catch (error) {
    yield put(editAccountSettingSuccess({ responseMessage: "Error while editing User Details", responseStatus: "Error" }))
    console.log(error)
  }
}

function* watchForDeleteApplication({ payload }) {
  try {
    const EditAppResult = yield call(LystfaceDeleteApp, payload)
    if (EditAppResult.responseCode == true) {
      yield put(setDeleteApplicationStatus(EditAppResult))
    } else {
      yield put(setDeleteApplicationStatus(EditAppResult))

    }
  } catch (error) {
    console.log(error)
    yield put(setDeleteApplicationStatus({ responseStatus: "Error", responseMessage: "There was an error deleting the application, please try again later!" }))
  }
}
function* watchForVerifyOTP({ payload: { data, from } }) {
  try {
    const Result = yield call(LystfaceVerifyOTP, data)
    const Response = { ...Result, from: from }
    if (Result.responseCode) {
      yield put(setOTPStatus(Response))
    } else {
      yield put(setOTPStatus(Response))

    }
  } catch (error) {
    console.log(error)
    yield put(setOTPStatus({ responseCode: 0, responseStatus: "Error", responseMessage: "There was an error verifying otp, please try again later!" }))
  }
}
function* watchForVerifyEmail({ payload }) {
  try {
    const Result = yield call(LystfaceVerifyEmail, payload)
    if (Result.responseCode) {
      yield put(setVerifyEmail(Result))
    } else {
      yield put(setVerifyEmail(Result))

    }
  } catch (error) {
    console.log(error)
    yield put(setVerifyEmail({ responseCode: 0, responseStatus: "Error", responseMessage: "There was an error verifying email, please try again later!" }))
  }
}
function* watchForVerifyLoginOTP({ payload: { data, history } }) {
  try {
    const Result = yield call(LystfaceVerifyLoginOTP, data)
    if (Result.responseCode) {
      yield put(setOTPLoginStatus(Result))
      Cookies.set("SESSION_ID", true)
      history("/dashboard")
    } else {
      yield put(setOTPLoginStatus(Result))

    }
  } catch (error) {
    console.log(error)
    yield put(setOTPLoginStatus({ responseCode: 0, responseStatus: "Error", responseMessage: "There was an error verifying otp, please try again later!" }))
  }
}
function* watchForTwoFactorAuth({ payload }) {
  const { factor: enabled } = payload
  try {
    const Result = yield call(LystfaceTwoFactorAuth, payload)
    if (Result.responseCode) {
      yield put(setTwoFactorAuthStatus({ ...Result, enabled }))
    } else {
      yield put(setTwoFactorAuthStatus(Result))

    }
  } catch (error) {
    console.log(error)
    yield put(setTwoFactorAuthStatus({ responseCode: 0, responseStatus: "Error", responseMessage: "There was an error two factor authentication, please try again later!" }))
  }
}
function* watchForResendOTP({ payload: { data, from } }) {
  try {
    const Result = yield call(LystfaceResendOTP, data)
    const Response = { ...Result, from: from }
    if (Response.responseCode) {
      yield put(setResendOtpStatus(Response))
    } else {
      yield put(setResendOtpStatus(Response))

    }
  } catch (error) {
    console.log(error)
    yield put(setResendOtpStatus({ responseCode: 0, responseStatus: "Error", responseMessage: "There was an error sending otp, please try again later!" }))
  }
}
function* watchForResendLoginOTP({ payload: { data, from } }) {
  try {
    const Result = yield call(LystfaceResendLoginOTP, data)
    const Response = { ...Result, from: from }
    if (Response.responseCode) {
      yield put(setResendLoginOtpStatus(Response))
    } else {
      yield put(setResendLoginOtpStatus(Response))

    }
  } catch (error) {
    console.log(error)
    yield put(setResendLoginOtpStatus({ responseCode: 0, responseStatus: "Error", responseMessage: "There was an error sending otp, please try again later!" }))
  }
}

function* watchForVerifyCurrentPswd({ payload }) {
  try {
    const Result = yield call(LystfaceVerifyCurrentPswd, payload)
    if (Result.responseCode) {
      yield put(setVerifyCurrentPassword(Result))
    } else {
      yield put(setVerifyCurrentPassword(Result))

    }
  } catch (error) {
    console.log(error)
    yield put(setResendOtpStatus({ responseCode: 0, responseStatus: "Error", responseMessage: "There was an error verifying password, please try again later!" }))
  }
}
function* watchForSendEmail({ payload }) {
  try {
    const Result = yield call(LystfaceSendEmail, payload)
    if (Result.responseCode) {
      yield put(setSendEmailStatus(Result))
    } else {
      yield put(setSendEmailStatus(Result))

    }
  } catch (error) {
    console.log(error)
    yield put(setResendOtpStatus({ responseCode: 0, responseStatus: "Error", responseMessage: "There was an error sending email, please try again later!" }))
  }
}
function* watchForUpdateContactDetails({ payload }) {
  try {
    let updatedPayload = null
    const { from, cid, cmp_phone, cmp_email, cmp_phone_code } = payload
    if (from === "email") {
      updatedPayload = { cmp_email }
    }
    else {
      updatedPayload = { cmp_phone, cid }

    }
    const Result = yield call(LystfaceUpdateContact, updatedPayload)
    if (Result.responseCode) {
      yield put(setUpdateContactDetails({ ...Result, payload }))
    } else {
      yield put(setUpdateContactDetails(Result))

    }
  } catch (error) {
    console.log(error)
    yield put(setResendOtpStatus({ responseCode: 0, responseStatus: "Error", responseMessage: "There was an error updating details, please try again later!" }))
  }
}

function* HomeMenuSaga() {
  yield takeEvery(CREATE_APPLICATION, watchForCreateApplication)
  yield takeEvery(EDIT_APPLICATION, watchForEditApplication)
  yield takeEvery(REGENERATE_APP_KEY, watchForRegenerateAppKey)
  yield takeEvery(GET_ACCOUNT_SETTING, getAccountDataApi)
  yield takeEvery(CHANGE_PASSWORD, changePassword)
  yield takeEvery(EDIT_ACCOUNT_SETTING, editAccountSetting)
  yield takeEvery(DELETE_APPLICATION, watchForDeleteApplication)
  yield takeEvery(VERIFY_OTP, watchForVerifyOTP)
  yield takeEvery(TOGGLE_TWO_FACTOR_AUTH, watchForTwoFactorAuth)
  yield takeEvery(RESEND_OTP, watchForResendOTP)
  yield takeEvery(VERIFY_CURRENT_PASSWORD, watchForVerifyCurrentPswd)
  yield takeEvery(SEND_EMAIL, watchForSendEmail)
  yield takeEvery(UPDATE_CONTACT_DETAILS, watchForUpdateContactDetails)
  yield takeEvery(VERIFY_LOGIN_OTP, watchForVerifyLoginOTP)
  yield takeEvery(VERIFY_EMAIL, watchForVerifyEmail)
  yield takeEvery(RESEND_LOGIN_OTP, watchForResendLoginOTP)
}

export default HomeMenuSaga
